module.exports = __webpack_public_path__ + "img/Profile-4.f771e600.png";